import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Phone } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card, CardBody } from '../components/ui/Card';
export function FleetSUVs() {
  // Generate 20 SUVs
  const suvs = Array.from({
    length: 20
  }).map((_, i) => {
    const models = ['Ford Explorer', 'Chevy Traverse', 'Honda Pilot', 'Hyundai Palisade', 'Toyota Highlander', 'Kia Telluride', 'Subaru Ascent', 'Nissan Pathfinder'];
    const years = ['2022', '2023', '2024', '2025'];
    const prices = [50, 55, 60, 65, 70, 75];
    const model = models[i % models.length];
    const year = years[i % years.length];
    const price = prices[i % prices.length];
    const imageIds = ['1519641471654-76ce0107ad1b', '1606664515524-ed2f786a0bd6', '1533473359331-0135ef1b58bf', '1503376780353-7e6692767b70', '1563720223-23d53b816617'];
    const imageId = imageIds[i % imageIds.length];
    return {
      id: i,
      name: `${model} Accessible`,
      year,
      price: `$${price}/hr`,
      description: `Affordable ${model} featuring spacious interiors, lowered floors, and automated side-entry ramps for seamless wheelchair access and equipment shipping.`,
      image: `https://images.unsplash.com/photo-${imageId}?w=600&h=400&fit=crop&q=80&sig=${i}`
    };
  });
  return <div className="bg-warm-50 min-h-screen pb-20" data-id="element-487">
      <div className="bg-white py-12 border-b border-warm-200 mb-12" data-id="element-488">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-489">
          <Link to="/fleet" className="inline-flex items-center text-primary-600 hover:text-primary-800 font-medium mb-6 transition-colors" data-id="element-490">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-491" /> Back to Fleet Overview
          </Link>
          <h1 className="text-4xl font-extrabold text-black mb-4" data-id="element-492">
            Wheelchair Accessible SUVs
          </h1>
          <p className="text-lg text-warm-600 max-w-3xl" data-id="element-493">
            Browse our complete inventory of modified SUVs and crossovers
            offering the perfect blend of style, space, and accessibility.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-494">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-495">
          {suvs.map(vehicle => <Card key={vehicle.id} className="rounded-2xl shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300 border-none bg-white flex flex-col h-full" data-id="element-496">
              <img src={vehicle.image} alt={vehicle.name} className="w-full h-48 object-cover" data-id="element-497" />
              <CardBody className="p-6 flex flex-col flex-grow" data-id="element-498">
                <div className="flex justify-between items-start mb-2" data-id="element-499">
                  <h3 className="text-xl font-bold text-black leading-tight" data-id="element-500">
                    {vehicle.name}
                  </h3>
                  <span className="bg-warm-100 text-warm-800 text-xs font-bold px-2 py-1 rounded" data-id="element-501">
                    {vehicle.year}
                  </span>
                </div>
                <p className="text-primary-600 font-bold text-lg mb-3" data-id="element-502">
                  {vehicle.price}
                </p>
                <p className="text-warm-600 text-sm mb-6 flex-grow" data-id="element-503">
                  {vehicle.description}
                </p>
                <div className="flex gap-3 mt-auto items-stretch" data-id="element-504">
                  <Link to="/booking" className="flex-1 flex" data-id="element-505">
                    <Button variant="primary" size="sm" className="w-full h-full" data-id="element-506">
                      Call
                    </Button>
                  </Link>
                  <Link to="/booking" className="flex-1 flex" data-id="element-507">
                    <Button variant="outline" size="sm" className="w-full h-full border-2" data-id="element-508">
                      Hire Now
                    </Button>
                  </Link>
                </div>
              </CardBody>
            </Card>)}
        </div>

        <div className="mt-20 bg-black rounded-3xl p-10 text-center text-white shadow-2xl" data-id="element-509">
          <h2 className="text-3xl font-bold mb-4" data-id="element-510">
            Need help choosing the right SUV?
          </h2>
          <p className="text-warm-400 mb-8 max-w-2xl mx-auto" data-id="element-511">
            Our mobility specialists are available 24/7 to help you find the
            perfect vehicle for your specific needs.
          </p>
          <a href="tel:2404132157" data-id="element-512">
            <Button size="lg" className="bg-primary-600 hover:bg-primary-700 text-white border-none" data-id="element-513">
              <Phone className="w-5 h-5 mr-2" data-id="element-514" /> Call (240) 413-2157
            </Button>
          </a>
        </div>
      </div>
    </div>;
}